__turbopack_context__.v({
  "cardContent": "index-module-scss-module__CtswSG__cardContent",
  "cardImage": "index-module-scss-module__CtswSG__cardImage",
  "cardImageContainer": "index-module-scss-module__CtswSG__cardImageContainer",
  "carousel": "index-module-scss-module__CtswSG__carousel",
  "desg": "index-module-scss-module__CtswSG__desg",
  "details": "index-module-scss-module__CtswSG__details",
  "name": "index-module-scss-module__CtswSG__name",
  "shortDesc": "index-module-scss-module__CtswSG__shortDesc",
  "studentPlayIcon": "index-module-scss-module__CtswSG__studentPlayIcon",
  "testimonialBox": "index-module-scss-module__CtswSG__testimonialBox",
  "videoImg": "index-module-scss-module__CtswSG__videoImg",
});
